import React from 'react';
import { Link } from 'react-router-dom';
import './ModernFooter.css'; // Import the new CSS file
import FacebookIcon from './icons/FacebookIcon.js';
import InstagramIcon from './icons/InstagramIcon.js';
import TikTokIcon from './icons/TikTokIcon.js';

const ModernFooter = () => {
  return (
    <footer className="modern-footer">
      <div className="container">
        <div className="grid-section">
          
          {/* Brand Section */}
          <div className="brand-section">
            <Link to="/">
              <img
                src="/saltlogo.png"
                alt="SaltFishy Logo"
                style={{ height: '80px', width: 'auto' }}
              />
            </Link>
            <p>
              Premium marine fish from the pristine waters of the Maldives. Quality guaranteed with every purchase from our trusted facility.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4>Quick Links</h4>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/shop">Fish Collection</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Information */}
          <div>
            <h4>Information</h4>
            <ul>
              <li>
                <Link to="/faq">Shipping Policy</Link>
              </li>
              <li>
                <Link to="/care-guide">Care Guides</Link>
              </li>
              <li>
                <Link to="/faq">FAQ</Link>
              </li>
              <li>
                <Link to="/admin">Admin Login</Link>
              </li>
            </ul>
          </div>

          {/* Contact Us */}
          <div>
            <h4>Contact Us</h4>
            <div className="contact-info">
              <a href="https://wa.me/9609977542" target="_blank" rel="noopener noreferrer">
                WhatsApp: +960 9977542
              </a>
              <a href="mailto:hello@saltfishy.com">
                hello@saltfishy.com
              </a>
            </div>
            
            <h4>Follow Us</h4>
            <div className="social-links">
              <a
                href="https://facebook.com/saltfishy"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Facebook"
              >
                <FacebookIcon />
              </a>
              <a
                href="https://instagram.com/saltfishy"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Instagram"
              >
                <InstagramIcon />
              </a>
              <a
                href="https://tiktok.com/@saltfishy"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="TikTok"
              >
                <TikTokIcon />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="bottom-section">
          <p>
            © {new Date().getFullYear()} SaltFishy. All rights reserved.
          </p>
          <p className="heart-text">
            Made with <span className="heart-icon">❤️</span> for aquarium lovers
          </p>
        </div>
      </div>
    </footer>
  );
};

export default ModernFooter;
